import React from 'react';
import classNames from 'classnames';

import { Consulting } from '@layouts/Consulting';
import { DescriptionWithImage, QuoteWithButtons } from '@components';
import teamHightFive from '@images/team-high-five.svg';
import calculator from '@static/images/figures/calculator.webp';
import { Header } from './components';
import { contacts } from '@store/ContactData';

import * as styles from './DedicatedTeam.module.scss';

export const DedicatedTeam: React.FC = () => {
	return (
		<>
			<Header />
			<DescriptionWithImage
				image={teamHightFive}
				className="gray-bg pt-xl-0 pb-0"
				contentClassName={classNames(
					styles.content,
					'd-flex flex-column justify-content-center'
				)}
				imageBoxClassName={styles.imageBox}
			>
				<h2 className="font-600 mb-2">Is Dedicated Team for me?</h2>
				<div className="font-size-sm line-height-sm">
					If you are looking for a team that will be 100% committed to your
					project full time and does not intend to recruit new employees at the
					moment, and you want to reduce payrolls, and speedup your project
					implementations. - this model is the most beneficial. A dedicated team
					allows you to involve qualified professionals with the right skills
					quickly, without spending time on recruitment and pieces of training.
					In this case, you are engaging your team quickly and can start your
					project soon.
				</div>
			</DescriptionWithImage>
			<QuoteWithButtons
				author={{
					name: contacts[0].name,
					position: contacts[0].position,
					email: contacts[0].email,
					linkedIn: contacts[0].linkedin,
					photo: contacts[0].image,
				}}
			>
				<h2 className="font-size-22 font-600 mb-2 pr-5">
					What kind of competencies are you looking for?
				</h2>
				<p className="font-size-sm line-height-sm">
					Contact me to discuss your requirements and build your dedicated IT
					team together with us.{' '}
				</p>
			</QuoteWithButtons>
			<DescriptionWithImage
				image={calculator}
				className="gray-bg"
				imageClassName={styles.calculatorImage}
				imageBoxClassName="justify-content-center justify-content-md-end"
				imageOnRight
			>
				<h2 className="font-600 mb-2">How do you calculate FTE?</h2>
				<div className="font-size-sm line-height-sm">
					The monthly rate per dedicated team is calculated individually. Offer
					always includes discounts for engaging the whole team - the cost is
					more beneficial than the individual hourly rate per person. The offer
					is based on the competencies of hired specialists.
				</div>
			</DescriptionWithImage>
			<Consulting />
		</>
	);
};
